import {
  Dic,
  Dates
} from '$utils'
export const taskOption = function (that) {
  return {
    column: [{
        label: that.$t('historyAlarm.label.taskName'),
        prop: 'taskName',
        span: 24
      },
      {
        label: that.$t('historyAlarm.label.creatorName'),
        prop: 'creatorName',
        span: 8
      },
      {
        label: that.$t('historyAlarm.label.taskType'),
        prop: 'taskType',
        dicData: Dic.find('SENU010'),
        span: 8
      },
      {
        label: that.$t('historyAlarm.label.status'),
        prop: 'status',
        dicData: Dic.find('SENU012'),
        span: 8
      },
      {
        label: that.$t('historyAlarm.label.taskPriority'),
        prop: 'taskPriority',
        dicData: Dic.find('SENU008'),
        span: 8
      },
      {
        label: that.$t('historyAlarm.label.taskVisibility'),
        prop: 'taskVisibility',
        dicData: Dic.find('SENU009'),
        span: 16
      },
      {
        label: that.$t('historyAlarm.label.createTime'),
        prop: 'createTime',
        type: 'daterange',
        formatter: function (row, value) {
          return value ? Dates.dayjs(value).format("YYYY-MM-DD HH:mm:ss") : "";
        },
        span: 24
      },
      {
        label: that.$t('historyAlarm.label.desc'),
        prop: 'desc',
        span: 24
      }
    ]
  }
}
export const taskOptionFinish = function (that) {
  return {
    column: [{
        label: that.$t('historyAlarm.label.taskName'),
        prop: 'taskName',
        span: 24
      },
      {
        label: that.$t('historyAlarm.label.creatorName'),
        prop: 'creatorName',
        span: 8
      },
      {
        label: that.$t('historyAlarm.label.taskType'),
        prop: 'taskType',
        dicData: Dic.find('SENU010'),
        span: 8
      },
      {
        label: that.$t('historyAlarm.label.status'),
        prop: 'status',
        dicData: Dic.find('SENU012'),
        span: 8
      },
      {
        label: that.$t('historyAlarm.label.taskPriority'),
        prop: 'taskPriority',
        dicData: Dic.find('SENU008'),
        span: 8
      },
      {
        label: that.$t('historyAlarm.label.taskVisibility'),
        prop: 'taskVisibility',
        dicData: Dic.find('SENU009'),
        span: 16
      },
      {
        label: that.$t('historyAlarm.label.createTime'),
        prop: 'createTime',
        type: 'daterange',
        formatter: function (row, value) {
          return value ? Dates.dayjs(value).format("YYYY-MM-DD HH:mm:ss") : "";
        },
        span: 24
      },
      {
        label: that.$t('historyAlarm.label.modifyTime'),
        prop: 'modifyTime',
        type: 'daterange',
        formatter: function (row, value) {
          return value ? Dates.dayjs(value).format("YYYY-MM-DD HH:mm:ss") : "";
        },
        span: 24
      },
      {
        label: that.$t('historyAlarm.label.desc'),
        prop: 'desc',
        span: 24
      }
    ]
  }
}
export const tapOption = function (that) {
  return {
    column: [{
        label: that.$t('historyAlarm.label.executive'),
        prop: 'tab1'
      },
      {
        label: that.$t('historyAlarm.label.doDetail'),
        prop: 'tab2'
      }
      // ,
      // {
      //   label: that.$t('historyAlarm.label.alarmDetail'),
      //   prop: 'tab3'
      // }
    ]
  }
}

export const taskAlarmOption = function (that) {
  return {
    column: [{
        label: that.$t('historyAlarm.title.alarmName'),
        prop: 'alarmId',
        span: 6
      },
      {
        label: that.$t('historyAlarm.title.alarmType'),
        prop: 'alarmType',
        dicData: Dic.find('SENU004005'),
        span: 18
      },
      {
        label: that.$t('historyAlarm.title.alarmLevel'),
        prop: 'alarmLevel',
        dicData: Dic.find('SENU017'),
        span: 6
      },
      {
        label: that.$t('historyAlarm.title.alarmTime'),
        prop: 'alarmTime',
        type: 'daterange',
        formatter: function (row, value) {
          return value ? Dates.dayjs(value).format("YYYY-MM-DD HH:mm:ss") : "";
        },
        span: 18
      },
      {
        label: that.$t('historyAlarm.title.alarmLoca'),
        prop: 'groupName',
        span: 6
      }
    ]
  }
}